<template>
	<div class="home_wrapper">
		<div 
			class="home_container" 
			v-lazy:background-image="homeContainerBackgroundImage">
			<HelloWorldMobile msg="This is views-mobile-HomeView" />
		</div>

		<ApplySenceMobile v-if="isHideForTest" />

		<ProductsServicesMobile />

		<GlobalGameMobile v-if="isHideForTest" />

		<GlobalDeploymentMobile v-if="isHideForTest" />

		<BusinessCooperationMobile />
		
		<FooterMenuMobile />
	</div>
</template>

<script>
/**
 * Mobile HomeView
 * @ is an alias to /src
 */
import { mapState }              from 'vuex';
import HelloWorldMobile          from '@/components/mobile/HelloWorld.vue';
import ApplySenceMobile          from '@/components/mobile/ApplySence.vue';
import ProductsServicesMobile    from '@/components/mobile/ProductsServices.vue';
import GlobalGameMobile          from '@/components/mobile/GlobalGame.vue';
import GlobalDeploymentMobile    from '@/components/mobile/GlobalDeployment.vue';
import BusinessCooperationMobile from '@/components/mobile/BusinessCooperation.vue';
import FooterMenuMobile          from '@/components/mobile/FooterMenu.vue';
import { goToHome }              from '@/utils/routerUtils';
import {
	NAV_IS_PAGE_SCROLL
} from '@/type/mutation';

export default {
	name      : 'HomeViewMobile',
	components: {
		HelloWorldMobile,
		ApplySenceMobile,
		ProductsServicesMobile,
		GlobalGameMobile,
		GlobalDeploymentMobile,
		BusinessCooperationMobile,
		FooterMenuMobile
	},
	data() {
		return {
			// 父级容器背景图
			homeContainerBackgroundImagePc    : require('../../assets/static/imgs/home/index-bg-b0.png'),
			homeContainerBackgroundImageMobile: require('../../assets/static/imgs/home/m/index-bg-b0-m.png'),
		};
	},

	mounted() {
		window.scrollTo(0, 0);

		// 动态添加背景图
		// this.addBackgroundImage();

		// 监听页面滚动
    	window.addEventListener('scroll', this.handleScroll);
	},

	methods: {
		// 动态添加背景图
		addBackgroundImage()
		{
			const container = document.querySelector('.home_container');
			if(this.$Common.isMobile())
			{
				// container.style.background = `rgba(162, 112, 234, .2) url(${this.homeContainerBackgroundImage}) center bottom no-repeat`;
				// container.style.background = `url(${this.homeContainerBackgroundImageMobile})`;
				this.homeContainerBackgroundImage = this.homeContainerBackgroundImageMobile;
			}
			else
			{
				// container.style.background = `url(${this.homeContainerBackgroundImagePc})`;
				this.homeContainerBackgroundImage = this.homeContainerBackgroundImagePc;
			}
			container.style.backgroundPosition = `top center`;
			container.style.backgroundRepeat   = `no-repeat`;
			container.style.backgroundSize     = `cover`;
		},

		// 监听页面滚动
		handleScroll()
		{
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
			// console.log('=== HomeView__handleScroll__scrollTop >>>', scrollTop);
	        if(scrollTop)// 如果滚动距离大于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, true);
	      	}
			else if(scrollTop === 0)// 如果滚动距离等于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, false);
	      	}
		},

		// 跳转至首页
		goHome()
		{
			goToHome(this.$router);
		},

		// 跳转至全部游戏页
		gotoAllGames()
		{
			this.$router.push('/allgames');
		}
	},
	computed: {
		// ES6展开合并运算符
		...mapState(['isHideForTest']),

		homeContainerBackgroundImage()
		{
			return this.$Common.isMobile() ? this.homeContainerBackgroundImageMobile : this.homeContainerBackgroundImagePc;
		}
	},

	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	}
}
</script>

<style lang="less" scoped>
.home_wrapper{
	width:var(--com-base-container-wm);height:auto;
	margin:0 auto;padding-top:0;
}
.home_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h2m);
	margin:0 auto;
	background-position:top center;
	background-repeat:no-repeat;
	background-size:cover;
}
</style>
